import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Quote, Star } from 'lucide-react';
interface Testimonial {
  quote: string;
  author: string;
  role: string;
  stars: number;
  image?: string;
}
export function NewTestimonials() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const testimonials: Testimonial[] = [{
    quote: "Ali... Brenden... I can't stress enough how working with this team is guaranteed to provide transformations... Working with them is just a fantastic experience and I highly recommend this to anybody who's even considering, if you're looking for something life-changing, if you want to attack diseases that the mainstream says is not really something treatable, give them a shot because they're going to show you that chances are it's something you can reverse or at the very least slow down... It will blow your mind. That's what I can guarantee.",
    author: 'Sean L.',
    role: 'Transformation Client',
    stars: 5
  }, {
    quote: 'I really enjoy your video lessons and have learned alot and am very impressed with your profound knowledge and understanding... As you might know I am a physician with an integrative medicine practice and your work has been very valuable in treating my patients. When I lecture to physicians I always mention "peptide mastery" as a great source of material and extensive references... It has been very helpful in my care of patients and I appreciate the extensive references.',
    author: 'Ronald R., MD',
    role: 'Peptide Mastery buyer',
    stars: 5
  }, {
    quote: "I 100% would put my name behind Ali & Brenden. I've had other health coaches in the past (most are MD's), and I must say, Brenden & Ali are FAR more in depth, systems-oriented, and rigorous than anything I've ever seen. Also I did grab that peptides course. It has given me the knowledge to turn familys' health conditions around even when the medical system has failed them. I owe this to the lessons I've acquired from Ali & Brenden. In terms of level of positive impact on my life, they are likely in the top 5 most important people I've ever met as they have added many years to my life and to those of my loved ones.",
    author: 'Wilfred A.',
    role: 'Software engineer & biological enhancement enthusiast',
    stars: 5
  }, {
    quote: "I've seen Brenden dissect complex pharmacological mechanisms and explain them in a way that makes sense to both medical professionals and laypeople alike. He's able to predict outcomes and potential applications that others simply don't see. He's not afraid to challenge conventional wisdom when the science doesn't support it. In a field often clouded by hype and misinformation, Brenden's dedication to truth is refreshing and invaluable. As the director of ReadyMed, I've worked with countless physicians, hormone specialists, and pharmacists over the years. But I can say without hesitation that Brenden Henry's knowledge of peptides, pharmacology, and human biology is truly in a league of its own.",
    author: 'EM.',
    role: 'Director at ReadyMed',
    stars: 5
  }, {
    quote: "If you think you know peptides, think again. This course is next-level stuff. The Peptide Mastery course seemed too good to be true, but the expertise of Brenden Henry and the extensive research behind each module convinced me to give it a try. I'm amazed at the results. My performance in the gym, at work, everywhere - it's all up. From improved recovery times to enhanced mental clarity, the benefits have been transformative. This course doesn't just teach you about peptides; it gives you the tools to optimize your biology.",
    author: 'Michael T.',
    role: 'Peptide Mastery buyer',
    stars: 5
  }, {
    quote: "I was skeptical as hell about this peptide thing. Thought it was just another way to empty my wallet. But man, was I wrong. This Peptide Mastery course is the real deal. It's like I've unlocked cheat codes for my body. Sleep better, think clearer, feel stronger – I just keep feeling better over time. And it's not just in the way I feel – my bloodwork is showing improvements my doc can't explain. If you're on the fence, just do it. Your future self will thank you.",
    author: 'Alexander P.',
    role: 'Strategic consultant',
    stars: 5
  }, {
    quote: "I want to thank you from the bottom of my heart for looking at my husband's MRIs and telling me that he needs the shunt. The neurologist is going to schedule a spinal tap for Paul. I am so happy, but now nervous too, since we will see if Paul is able to show benefit in the span of a couple hours so to convince a surgeon to do the shunt surgery. What you told me about the 2021 MRI is making so much sense to me. It made me remember that Paul had hit his head in a fall on our icy driveway not long before the CO poisoning. So with what you said, it really connects the dots as to why maybe Paul had such a worse outcome than me. It was such a mystery. I am so grateful for you and I am giving much thanks to God for you.",
    author: 'Bev B.',
    role: '',
    stars: 5
  }, {
    quote: "I f**king love you man. I am now officially completely cured and honestly I'm just excited to see how much further we can take things!!",
    author: 'Michal J.',
    role: '',
    stars: 5
  }, {
    quote: "Thank you Ali. I feel like you are a nephew to me now. It's hard to not blame myself for missing the choline deficiency, but you and Brenden have been a light for both of us. You have done what our entire team of medical professionals were not able to do. I am looking forward to doing a program with you myself after my husband's recovery 🙏",
    author: 'Badar A.',
    role: '',
    stars: 5
  }, {
    quote: "As a doctor myself, I was skeptical of anything outside standard cardiology protocols. But conventional medicine had nothing left to offer me except a new heart. What you've done isn't just impressive—it's life-changing.",
    author: 'Glen S.',
    role: 'Transformation Client',
    stars: 5
  }, {
    quote: "At a most challenging time in my life you are all truly a gift from the Universe. I count my blessings daily. Brenden's call was so thorough and we did as deep a dive into my health as the time would allow. I look forward to beginning the journey with him especially reading about the training protocols offered as I have hit a bit of a wall with mine including muscle soreness and pain. He explained how comprehensive the program will be and I feel like 'Toto we aren't in Kansas anymore' lol. Ali, You and Brenden - the best triple threat in the Healthspan/Lifespan space.",
    author: 'Shawna C.',
    role: '',
    stars: 5
  }, {
    quote: "Almost 2 months giving my grandma with Alzheimer's [specific peptide protocol]. The life has come back into her eyes. Thank you for telling the world about this stuff. Many blessings are being given to people as a result.",
    author: 'Charlemagne',
    role: 'Consulting client',
    stars: 5
  }, {
    quote: "Update on grandparents with peptides: He just called me to update me he feels 20 years younger and she is doing yard work AND just did a 100 piece jigsaw puzzle (she's loved puzzles her whole life). 6 months ago she couldn't do a five piece jigsaw puzzle. I don't care what anyone says, peptides f**king work.",
    author: 'Kademlia',
    role: 'Coaching client & Peptide Mastery buyer',
    stars: 5
  }, {
    quote: "I'm going through the peptide mastery and all the other peptide courses and resources I've purchased from you guys (I am LOVING it all!!). I'm a functional medicine practitioner and I can't wait to incorporate some of these protocols with my patients!!!",
    author: 'Michelle M.N.',
    role: 'DC, CFMP',
    stars: 5,
    image: 'https://cdn.magicpatterns.com/uploads/dPyPPVvgoNLY4xTC94rdKn/MichelleMN.jpg'
  }, {
    quote: "I had knee surgery on one knee and a fractured kneecap and torn MCL on the other knee and I have osteoarthritis in both knees and my knees always hurt. They do not hurt at all while I'm on the peptides and I can even sit crosslegged.",
    author: 'Rachel A.',
    role: 'Coaching client',
    stars: 5
  }, {
    quote: "I really swear by those peptides I feel like I feel so much better and my stepmother has severe Alzheimer's and it has changed her life. It's really really crazy... That was a great call on your part because she couldn't even hold down a conversation for two minutes... It is truly a miracle.",
    author: 'Rachel A.',
    role: 'Health & wellness enthusiast, coaching client',
    stars: 5
  }];
  const renderStars = (count: number) => {
    return <div className="flex gap-1" data-id="element-2032" data-mp="lp0ezv5xvywi">
        {[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 ${i < count ? 'fill-amber-500 text-amber-500' : 'text-stone-600'}`} data-id="element-2033" data-mp="loic4forumfm" data-mpi={i} />)}
      </div>;
  };
  return <section className="relative py-16 sm:py-20 md:py-24 px-5 sm:px-6 bg-black" data-id="element-2034" data-mp="1edpks7hxwsel">
      <motion.div ref={ref} initial={{
      opacity: 0
    }} animate={inView ? {
      opacity: 1
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto" data-id="element-2035" data-mp="1ebl40oyxzyww">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif mb-10 sm:mb-16 text-center text-stone-100" style={{
        fontFamily: 'Cinzel, serif',
        textShadow: '0 0 30px rgba(217, 119, 6, 0.2)'
      }} data-id="element-2036" data-mp="1qprlnmwwm2xs">
          What People Are Saying
        </h2>

        <div className="grid md:grid-cols-2 gap-4 sm:gap-6 md:gap-8" data-id="element-2037" data-mp="24mesqiikm9hf">
          {testimonials.map((testimonial, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.05 * i
        }} className="border-2 border-amber-900/20 bg-gradient-to-br from-stone-950/40 to-black p-6 relative flex flex-col" data-id="element-2038" data-mp="29l87sfdia8jp" data-mpi={i}>
              <Quote className="w-6 h-6 text-amber-600/30 mb-3" data-id="element-2039" data-mp="2scra0jzphiko" />
              {renderStars(testimonial.stars)}
              <p className="text-stone-300 my-4 leading-relaxed text-sm flex-grow" data-id="element-2040" data-mp="1mfqc7ru0m8df">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-amber-900/30 pt-4 mt-2 flex items-center gap-4" data-id="element-2041" data-mp="1rebdzvox103z">
                {testimonial.image && <div className="relative flex-shrink-0" data-id="element-2042" data-mp="1wba668p0qwzj">
                    <div className="absolute inset-0 bg-amber-500/20 blur-md rounded-full" data-id="element-2043" data-mp="214muehpsd1rr" />
                    <img src={testimonial.image} alt={testimonial.author} className="relative w-16 h-16 rounded-full object-cover border-2 border-amber-500/30 shadow-[0_0_15px_rgba(245,158,11,0.2)]" style={{
                imageRendering: 'auto'
              }} data-id="element-2044" data-mp="254evk9cuo5n3" />
                  </div>}
                <div data-id="element-2045" data-mp="2k2z5wa466nqi">
                  <p className="font-bold text-stone-100 text-sm" data-id="element-2046" data-mp="2k1e6a6300els">
                    {testimonial.author}
                  </p>
                  {testimonial.role && <p className="text-xs text-stone-400" data-id="element-2047" data-mp="poenk43bn4aa">{testimonial.role}</p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}